import React from 'react';
import './App.css';
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {Layout} from "./Layout/Layout";
import {Science} from "./Science/Science";
import {Production} from "./Production/Production";
import {Mining} from "./Mining/Mining";
import {Smelting} from "./Smelting/Smelting";
import 'bootstrap/dist/css/bootstrap.min.css';
import {InventoryProvider} from "./State/InventoryContext";
import {HandCrafting} from "./Crafting/HandCrafting";
import {AssemblyPlanner} from "./Assembly/AssemblyPlanner";
import {Dashboard} from "./Dashboard/Dashboard";

function App() {
    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <InventoryProvider>
                <Routes>

                    <Route path="/" element={<Layout/>}>
                        <Route index element={<Dashboard/>}/>
                        <Route path="dashboard" element={<Dashboard/>}/>
                        <Route path="smelting" element={<Smelting/>}/>
                        <Route path="mining" element={<Mining/>}/>
                        <Route path="production" element={<Production/>}/>
                        <Route path="science" element={<Science/>}/>
                        <Route path="assembly" element={<AssemblyPlanner/>}/>
                        <Route path="crafting" element={<HandCrafting/>}/>
                        <Route path="create" element={<Navigate to="/crafting" replace />} />
                        <Route path="*" element={<Dashboard/>}/>
                    </Route>
                </Routes>
            </InventoryProvider>
        </BrowserRouter>
    );
}

export default App;
